import React, { useEffect, useState } from 'react';
import { createPortal } from "react-dom";
import DefaultMenuDrawerContent from './DefaultMenuDrawerContent';
import CustomDrawer from '@src/layout/AppLayout/AppDrawer/CustomDrawer';

export const DefaultMenuDrawer = (props: {
  open: boolean;
  onClose?: () => void;
  leftHeader?: React.ReactNode;
}) => {
  const {open, onClose, leftHeader} = props;
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted) return null;

  return createPortal(
    <CustomDrawer
      child={<DefaultMenuDrawerContent closeDrawer={onClose} />}
      isOpen={open}
      onToggleDrawer={onClose}
      isFromLanding={true}
      leftHeader={leftHeader}
    />, document.body
  );
};

export default DefaultMenuDrawer;
